import dynamic from 'next/dynamic';
import { Builder } from '@builder.io/sdk';
import { BuilderInputOptions } from '@/types/builder';
import { IconCardInputs } from './IconCard.config';

export { IconCardInputs };

const IconCard = dynamic(() => import('./IconCard').then((m) => ({ default: m.IconCard })));

const IconCardConfig = {
  name: 'IconCard',
  friendlyName: 'Card with Icon',
  defaultStyles: {
    margin: '0',
    flexGrow: '1',
    flexShrink: '1',
    flexBasis: '100%',
  },
  inputs: [
    ...IconCardInputs,
    {
      name: 'twoColumns',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'secondaryContents',
      type: 'richText',
      showIf: (options: BuilderInputOptions) => !!options.get('twoColumns'),
    },
  ],
};

Builder.registerComponent(IconCard, IconCardConfig);
